export default __webpack_public_path__ + "static/media/homeSaibaMaisHands.fa3a24b4.png";